import { render, staticRenderFns } from "./UploadImagens.vue?vue&type=template&id=8913f182&scoped=true&"
import script from "./UploadImagens.vue?vue&type=script&lang=js&"
export * from "./UploadImagens.vue?vue&type=script&lang=js&"
import style0 from "./UploadImagens.vue?vue&type=style&index=0&id=8913f182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8913f182",
  null
  
)

export default component.exports